import {ChangeDetectionStrategy, Component} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-field-pair",
    templateUrl: "./field-pair.component.html",
    styleUrl: "./field-pair.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: FieldPairComponent, multi: true}],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldPairComponent {
}
